<template>
  <div>
    <table class="table table-sm table-borderless" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
      <!-- <thead style="display: table-header-group;"> -->
      <tbody>
        <tr>
          <td>
            <cabecalho-generico
              :no_hide="true"
              :titulo="'Atendimento #' + dados.id_atendimento"
              v-if="dados && dados.paciente && dados.paciente.cadastro"
              :nome_empresa="nome_empresa"
              :show_logo="logo_url ? true : false"
              :logo="logo_url"
              :logo_posicao="logo_posicao"
              :hide_campos="tem_cabecalho_com_nome && logo_url">

              <template v-if="!tem_cabecalho_com_nome">

                <div>Paciente: 
                  <span v-if="dados.paciente.st_nome_social" class="mr-2">({{ dados.paciente.st_nome_social }})</span>
                  <span>{{ dados.paciente.st_nome }}</span>
                </div>
                <div>
                  <span v-if="dados.paciente.cadastro.st_cpf" class="mr-5">
                    CPF: {{ $util.formatMask(dados.paciente.cadastro.st_cpf, "cpf") }}
                  </span>
                  <span v-if="dados.paciente.cadastro.st_rg" class="mr-5">
                    RG: {{ dados.paciente.cadastro.st_rg }}
                  </span>
                  <span class="mr-5">
                    Data de Nascimento:
                    {{ $util.getFormatDate(dados.paciente.cadastro.dt_nascimento) }}
                  </span>
                </div>
                <div v-if="dados.paciente.cadastro.st_nome_mae">Mãe: 
                  <span>{{ dados.paciente.cadastro.st_nome_mae }}</span>
                </div>
                <div>
                  <span>
                    e-mail:
                    {{ dados.paciente.cadastro.st_email }}
                  </span>
                  <span class="mx-4">&nbsp;</span>
                  <span>
                    Telefone:
                    <span v-if="dados.paciente.cadastro.telefones.telefone" class="mr-3">
                      {{
                        $util.formatMask(
                          dados.paciente.cadastro.telefones.telefone,
                          dados.paciente.cadastro.telefones.telefone.length == 10
                            ? "tel"
                            : "cel"
                        )
                      }}
                    </span>
                    <span v-if="dados.paciente.cadastro.telefones.celular" class="mr-3">
                      {{
                        $util.formatMask(
                          dados.paciente.cadastro.telefones.celular,
                          dados.paciente.cadastro.telefones.celular.length == 10
                            ? "tel"
                            : "cel"
                        )
                      }}
                    </span>
                  </span>
                </div>
                <div v-if="dados.paciente.cadastro.endereco && dados.paciente.cadastro.endereco.exibir">
                  Endereço: <span class="small">{{ dados.paciente.cadastro.endereco.exibir }}</span>
                </div>

                <div class="mt-3" v-if="!reembolso">#{{ dados.id_atendimento }}
                  <span v-if="dados.st_codigo_reserva">
                    / {{ dados.st_codigo_reserva }}
                  </span>
                  <span v-if="dados.st_id_externo">
                    / {{ dados.st_id_externo }}
                  </span>
                </div>

                <div>Data: {{ $util.getFormatDate(dados.dt_inicio) }}</div>

                <div v-if="dados.unidade_operacao">
                  {{ dados.unidade_operacao.st_nome }}
                </div>

                <div v-if="!reembolso">{{ dados.plano.search }}
                  <span v-if="dados.plano.id_operadora != 1 && dados.atendimento.st_numero_carteira">
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                    Matrícula: {{ dados.atendimento.st_numero_carteira }}
                    <span v-if="dados.atendimento.dt_validade_carteira">
                      <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                      Validade: {{ $util.getFormatDate(dados.atendimento.dt_validade_carteira) }}
                    </span>
                  </span>
                </div>

                <div v-if="!reembolso && ( dados.procedimento.id_especialidade != 2 && dados.procedimento.id_especialidade != 67 )">{{ dados.atendimento.medico.search }}</div>

                <div v-if="dados.atendimento.st_observacao">
                  Obs.: {{ dados.atendimento.st_observacao }}
                </div>

              </template>

              <div class="mt-2" v-if="dados.cabecalho_laudo && dados.cabecalho_laudo.fl_campos_cabecalho && dados.cabecalho_laudo.js_campos_cabecalho">
                <table width="100%" v-for="(grupo, igx) in organizar_campos(dados.cabecalho_laudo.js_campos_cabecalho)" :key="igx" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
                  <tr>
                    <td v-for="(campo, icx) in grupo" :key="icx" :width="campo.largura + '%'">
                      <span v-if="campo.titulo" class="mr-1 text-muted">
                        {{ campo.titulo }}{{ campo.campo ? ':' : '' }}
                      </span>
                      {{ obter_valor(campo) }}
                    </td>
                  </tr>
                </table>
              </div>

              <div v-if="terceiro_logins(dados).length && !sem_login">
                <hr>
                <div v-for="(acesso, iax) in terceiro_logins(dados)" :key="iax">
                  <strong>Login: {{ acesso.st_login }} / Senha: {{ acesso.st_senha }}</strong>
                </div>
              </div>

              <div v-if="prazo_final">
                <hr>
                <strong>
                  Prazo de Entrega: {{ $util.getFormatDate(prazo_final) }}
                </strong>
              </div>

              <div v-if="dados && dados.cabecalho_laudo && dados.cabecalho_laudo.st_texto_rodape">
                <hr>
                <p style="white-space: pre-wrap;">{{ dados.cabecalho_laudo.st_texto_rodape }}</p>
              </div>
            </cabecalho-generico>
          </td>
        </tr>
      </tbody>
    </table>

        <!-- Lista de Exames -->
      
          <template v-if="!exibir_valor">
            <div class="form-row" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
              <div class="col" :class="col_size" v-for="(atp, iax) in lista_procedimentos" :Key="iax">
                <span :class="col_num <= 3 ? '' : 'small'">
                  <span v-if="dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_numerar_linhas">
                    {{ iax + 1 }}.
                  </span>
                  {{ atp.procedimento.search }}
                  <span class="ml-1" v-if="atp.js_solics && atp.js_solics.terc == 'S'">
                    (T)
                  </span>

                  <span v-if="atp.procedimento.id_modalidade_dicom" class="ml-2 small">
                      (AN: {{ atp.id_atendimento_procedimento }})
                  </span>
                </span>
              </div>
            </div>
              
            <template v-if="!dados || !dados.block_valores">
              <table class="table table-sm table-borderless" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
                <template v-if="dados.atendimento.pagamento_atendimento && dados.atendimento.pagamento_atendimento.desconto && dados.atendimento.pagamento_atendimento.desconto.dc_valor">
                  <tr>
                    <td class="d-flex justify-content-between">
                      <div>SUBTOTAL:</div>
                      <div>{{ $util.formatMoeda(total_geral) }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="d-flex justify-content-between">
                      <div>Desconto:</div>
                      <div>{{ $util.formatMoeda(dados.atendimento.pagamento_atendimento.desconto.dc_valor) }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="d-flex justify-content-between">
                      <div>TOTAL:</div>
                      <div>{{ $util.formatMoeda(total_geral - dados.atendimento.pagamento_atendimento.desconto.dc_valor) }}</div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td class="d-flex justify-content-between">
                      <div>TOTAL:</div>
                      <div>{{ $util.formatMoeda(total_geral) }}</div>
                    </td>
                  </tr>
                </template>
              </table>
            </template>
          </template>

          <template v-else>

            <table class="table table-sm" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
            
              <template v-for="(atp, iax) in lista_procedimentos">
                <tr :key="'I' + iax" v-if="true">
                  <td>{{ atp.procedimento.st_sigla }}</td>
                  <td>
                    <span v-if="atp.nao_coletar">
                        <i class="fas fa-ban fa-fw mr-2"></i>
                    </span>
                    <span 
                      v-else-if="atp.amostra_atendimento_procedimento && atp.amostra_atendimento_procedimento.amostra && atp.amostra_atendimento_procedimento.amostra.fl_pendente"
                      class="badge badge-secondary mr-2">
                      Pend
                    </span>
                    {{ atp.procedimento.search }}
                    <div class="ml-3 small" v-if="atp.id_atendimento_pacote && atp.procedimento_pacote && atp.procedimento_pacote.pacote && atp.procedimento_pacote.pacote.fl_combo && atp.procedimento_pacote.pacote.procedimento">
                      Pacote: {{ atp.procedimento_pacote.pacote.procedimento.search }}
                    </div>
                  </td>
                  <td class="small text-muted">
                    <span v-if="atp.medico">
                      #{{ atp.id_atendimento }} / {{ atp.medico.st_nome_exibicao }}
                    </span> 
                    <span v-else>
                      #{{ atp.id_atendimento }}
                    </span>

                    <span v-if="atp.procedimento.id_modalidade_dicom" class="ml-2 small">
                        (AN: {{ atp.id_atendimento_procedimento }})
                    </span>
                  </td>
                  <td><span v-if="atp.item_tabela">{{ atp.item_tabela.st_codigo }}</span></td>
                  <td>
                    <div v-if="false && prazo && atp.procedimento.in_prazo_entrega" class="small text-muted">
                      <template v-if="atp.dt_entrega">
                        Para: 
                        <span>{{ $util.getFormatDate(atp.dt_entrega) }}</span>
                      </template>
                      <template v-else>
                        Prazo: 
                        <span>{{ atp.procedimento.in_prazo_entrega }}</span>
                        <span class="ml-1">{{ traduzir_tempo(atp.procedimento.in_prazo_entrega, atp.procedimento.st_tempo_prazo_entrega) }}</span>
                      </template>
                    </div>
                  </td>
                  <td class="text-right">
                    <template v-if="atp.dc_valor_procedimento > 0 && ( !dados || !dados.block_valores )">
                      {{ $util.formatMoeda(atp.dc_valor_procedimento) }}
                      <span v-if="atp.in_quantidade > 1">
                        <i class="fas fa-times mx-2"></i>
                        {{ atp.in_quantidade }}
                        <i class="fas fa-equals mx-2"></i>
                        {{
                          $util.formatMoeda( ( atp.in_quantidade * atp.dc_valor_procedimento ) + ( atp.vl_tch ? atp.vl_tch : 0 ) )
                        }}
                      </span>
                    </template>
                  </td>
                </tr>
                <template v-if="atp && atp.atendimento_procedimento_consumos && atp.atendimento_procedimento_consumos.length && detalhe_despesas">
                  <tr v-for="(consumo, icx) in atp.atendimento_procedimento_consumos" :key="'CI' + iax + '.' + icx">
                    <th colspan="5">
                      <span class="ml-3" colspan="3">{{ consumo.search }}</span>
                      <span v-if="consumo.in_quantidade > 1" class="ml-5">
                        x{{ consumo.in_quantidade }}
                      </span>
                    </th>
                    <th class="text-right">
                      <span v-if="( !dados || !dados.block_valores )">{{ $util.formatMoeda(consumo.in_quantidade * consumo.dc_valor_unitario) }}</span>
                    </th>
                  </tr>  
                </template>
                
                <tr v-else-if="atp && atp.atendimento_procedimento_consumos && atp.atendimento_procedimento_consumos.length" :key="'C' + iax">
                  <th colspan="5"><span class="ml-3" colspan="3">Outras Despesas</span></th>
                  <th class="text-right">
                    <span v-if="( !dados || !dados.block_valores )">{{ $util.formatMoeda(total_consumos(atp)) }}</span>
                  </th>
                </tr>
              </template>

              <template v-if="!dados || !dados.block_valores">
                <template v-if="dados.atendimento.pagamento_atendimento && dados.atendimento.pagamento_atendimento.desconto && dados.atendimento.pagamento_atendimento.desconto.dc_valor">
                  <tr>
                    <td colspan="5">SUBTOTAL</td>
                    <td class="text-right">
                      {{ $util.formatMoeda(total_geral) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">Desconto</td>
                    <td class="text-right">
                      {{ $util.formatMoeda(dados.atendimento.pagamento_atendimento.desconto.dc_valor) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">TOTAL</td>
                    <td class="text-right">
                      {{ $util.formatMoeda(total_geral - dados.atendimento.pagamento_atendimento.desconto.dc_valor) }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="5">TOTAL</td>
                    <td class="text-right">
                      {{ $util.formatMoeda(total_geral) }}
                    </td>
                  </tr>
                </template>
              </template>
            </table>
            
          </template>

    <table class="table table-sm" :style="( dados && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte ) ? 'font-size: ' + dados.cabecalho_laudo.js_configs.espelho_tamanho_fonte + 'pt;' : ''">
        
      <tr v-if="dados.atendimento">
        <td colspan="100">
          <tiss-rodape
            :noresize="true"
            :large="true"
            :infoId="dados.atendimento.id_atendimento"
            :responsavel="atendimento_usuario()"></tiss-rodape>
        </td>
      </tr>

      <tr v-if="dados.texto_espelho">
        <td colspan="100">
          <hr>
          <span v-html="dados.texto_espelho"></span>
        </td>
      </tr>

      <tr v-if="!reembolso && dados.doc_pre_atends && dados.doc_pre_atends.length">
        <td colspan="100">
          <hr>
          <div v-for="(docpa, idx) in dados.doc_pre_atends" :key="idx" class="mb-3" style="page-break-inside: avoid;">
            <div class="border-bottom">{{ docpa.st_titulo }}</div>
            <formulario
              :compact="true"
              v-model="docpa.js_conteudo" 
              :saved="true" 
              mode="view"
              :config="true" />
          </div>
        </td>
      </tr>
        
      <tfoot>
        <tr>
          <td colspan="100">
            <div v-if="dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_rodape" style="white-space: pre-wrap;">{{ dados.cabecalho_laudo.js_configs.espelho_rodape }}</div>
            <div v-if="dados.unidade_operacao && dados.unidade_operacao.endereco && dados.cabecalho_laudo && dados.cabecalho_laudo.js_configs && dados.cabecalho_laudo.js_configs.espelho_endereco_rodape" style="white-space: pre-wrap;">{{ dados.unidade_operacao.endereco.exibir }}</div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
import CabecalhoGenerico from "../../relatorios/shared/CabecalhoGenerico.vue";
import TissRodape from "../../tiss/TissRodape";
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
  props: ["dados", "prazo", "sem_login", "reembolso", "sem_valor", "id_guia", "detalhe_despesas"],

  components: {
    CabecalhoGenerico,
    TissRodape,
    Formulario
  },

  computed: {
    col_num: function () { 
      if ( this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.js_configs && this.dados.cabecalho_laudo.js_configs.espelho_cols ) { 
        return this.dados.cabecalho_laudo.js_configs.espelho_cols;
      } 
      
      return 4;
    },

    col_size: function () { 
      if ( this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.js_configs && this.dados.cabecalho_laudo.js_configs.espelho_cols ) { 
        return 'col-' + ( 12 / this.dados.cabecalho_laudo.js_configs.espelho_cols );
      } 
      
      return 'col-3';
    },

    exibir_valor: function () { 
      if ( ( this.dados && this.dados.exibir_valor_espelho === false ) || this.sem_valor ) { 
        return false;
      }

      return true;
    },

    tem_cabecalho_com_nome: function () { 

      if ( this.dados && this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.fl_campos_cabecalho && this.dados.cabecalho_laudo.js_campos_cabecalho ) { 

        let teste = this.dados.cabecalho_laudo.js_campos_cabecalho.find((campo) => { 
            return campo && campo.campo == 'paciente.st_nome';
          });

        return teste ? true : false; 

      }

      return false;

    },

    logo_posicao: function () { 
      if ( this.dados.cabecalho_laudo 
        && this.dados.cabecalho_laudo.logo 
        && this.dados.cabecalho_laudo.logo.arquivo 
        && this.dados.cabecalho_laudo.logo.arquivo.temporary_url
        && this.dados.cabecalho_laudo.st_logo_posicao ) { 
        return this.dados.cabecalho_laudo.st_logo_posicao;
      }

      return null;
    },

    logo_url: function () { 
      if ( this.dados.cabecalho_laudo 
        && this.dados.cabecalho_laudo.logo 
        && this.dados.cabecalho_laudo.logo.arquivo 
        && this.dados.cabecalho_laudo.logo.arquivo.temporary_url ) { 
        return this.dados.cabecalho_laudo.logo.arquivo.temporary_url;
      }

      return null;
    },

    nome_empresa: function () { 
      if ( this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.st_nome_empresa ) { 
        return this.dados.cabecalho_laudo.st_nome_empresa;
      }

      return null;
    },

    total_geral: function () { 
      return this.valorTotal;

      /*
      return this.lista_procedimentos.reduce((total, carry) => { 
          return total + ( carry.in_quantidade * carry.dc_valor_procedimento ) + this.total_consumos(carry);
        }, 0);
      */
    },

    valorTotal: function () {
      let lista = _.cloneDeep(this.lista_procedimentos);

      if ( !lista )
        return -1;

      lista = lista.filter(item => this.dados.fl_particular || !item.id_plano_particular)
          .map((item, index) => {
              item.index = index;
              return item;
          });

      return _.uniqBy(lista, item => {
              return item.atendimento_pacote
                  ? 'P' + item.atendimento_pacote.id_pacote
                  : item.index;
          }).reduce((total, item) => {
              if ( item.id_atendimento_procedimento_empacotado )
                  return total;

              let consumos = item.atendimento_procedimento_consumos
              .filter(item => this.dados.fl_particular || !item.id_plano)
              .reduce((total, consumo) => {
                  return total + ( consumo.in_quantidade * consumo.dc_valor_unitario );
              }, 0);

              if ( item.atendimento_procedimento_equipes ) { 
                total = item.atendimento_procedimento_equipes.reduce ((total, membro) => {
                    return membro.dc_valor ? (total + (parseFloat(membro.dc_valor) * parseFloat(item.in_quantidade))) : total;
                }, total);
              } 

              if ( item.atendimento_pacote && ( !item.dc_valor_procedimento || ( !item.id_atendimento_procedimento && item.numero_sessao == 1 ) ) )
                  return total + ( ( item.atendimento_pacote.id_atendimento == item.id_atendimento || !item.atendimento_pacote.id_atendimento ) ? parseFloat(item.atendimento_pacote.dc_valor_pacote) : 0 ) + consumos;
              else
                  return total + ( ( item.ch_tipo_consulta == 'R' && item.procedimento.id_classe_procedimento == 1 ) ? 0 : item.dc_valor_procedimento * item.in_quantidade ) + consumos;
          }, 0);
    },

    lista_procedimentos: function () { 
      if ( !this.dados || !this.dados.atendimento || !this.dados.atendimento.atendimento_procedimentos )
        return [];

      let lista_outros = [];

      if ( this.dados.outras ) { 
        lista_outros = this.dados.outras.filter(item => item.id_marcacao != this.dados.id_marcacao && item.atendimento && item.atendimento.atendimento_procedimentos);
      }

      return this.dados.atendimento.atendimento_procedimentos.concat(
        lista_outros.flatMap(
          item => item.atendimento.atendimento_procedimentos.map(atp => { 
            return { 
              ...atp,
              medico: item.medico
            };
          })
        ) 
      )
      .filter(item => !this.id_guia || ( item.atendimento_procedimento_guia && item.atendimento_procedimento_guia.id_guia == this.id_guia ))
      .filter(item => item.procedimento && item.procedimento.search != 'EXAMES LABORATORIAIS' && !_.get(item, 'procedimento.js_info.block_esp'))
      .map(atp => { 

        if ( atp.atendimento_procedimento_consumos && atp.atendimento_procedimento_consumos.length ) { 
            let idx_tch = atp.atendimento_procedimento_consumos.findIndex(consumo => consumo.id_taxa && consumo.tch);

            if ( idx_tch >= 0 ) { 
                atp.dc_valor_procedimento = ( atp.dc_valor_procedimento * atp.in_quantidade ) + ( atp.atendimento_procedimento_consumos[idx_tch].dc_valor_unitario * atp.atendimento_procedimento_consumos[idx_tch].in_quantidade );
                atp.in_quantidade = 1; 
                atp.atendimento_procedimento_consumos.splice(idx_tch, 1);
            }
        }

        return atp;

      });
    },

    prazo_final: function () { 
      if ( !this.prazo )
        return;

      if ( this.dados && this.dados.unidade_operacao && !this.dados.unidade_operacao.fl_lab_pendente ) { 
        if ( this.lista_procedimentos.find(item => item.nao_coletar) ) { 
          return null;
        }
      }

      const maior = _.maxBy(this.lista_procedimentos, 'dt_entrega');

      return maior ? maior.dt_entrega : null;
    }
  },

  methods: {
    terceiro_logins (marcacao) { 
      if ( !marcacao || !marcacao.terceiro_logins || !marcacao.terceiro_logins.length )
        return [];

      return marcacao.terceiro_logins;
    },

    obter_valor(campo) { 
      let info = _.get(this.dados, campo.campo);

      if ( campo.campo && campo.campo.slice(-13) == 'dt_nascimento' ) { 
        info = this.$util.getFormatDate(info);
      } else if ( campo.campo && campo.campo.slice(-9) == 'dt_inicio' ) { 
        info = this.$util.getFormatDate(info.slice(0,10)) + ' ' + info.slice(11,16);
      }

      return info;
    },

    organizar_campos (campos) { 
      let lista = _.groupBy(
        _.orderBy(campos, ['linha','ordem']),
        'linha'
      );
      return lista;
    },

    traduzir_tempo(num, tempo) { 
      switch (tempo) {
        case 'days': return num > 1 ? 'dias úteis' : 'dia util';
        case 'hours': return num > 1 ? 'horas' : 'hora';
        default: 
          if ( !tempo ) { 
            return num > 1 ? 'dias úteis' : 'dia util';
          }
      }

      return tempo;
    },

    total_consumos(atp) { 
      return atp.atendimento_procedimento_consumos.reduce((total, carry) => { 
        return total + ( carry.in_quantidade * carry.dc_valor_unitario );
      }, 0);
    },

    atendimento_usuario() {
      if (this.dados.atendimento.usuario) {
        return this.dados.atendimento.usuario.st_login;
      }

      return null;
    }
  }
};
</script>
